var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 318.18 295",
    style: {
      enableBackground: "new 0 0 318.18 295"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000058578497010298956850000006891328794458542210_);}\n\t.st2{fill:url(#SVGID_00000016784783381512688900000014208616990330879619_);}\n\t.st3{fill:url(#SVGID_00000111875937967923708190000007181593499575045014_);}\n\t.st4{fill:url(#SVGID_00000055678127205709248260000009857510322552954808_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -901.8062,
    y1: -820.7233,
    x2: 1057.2983,
    y2: 998.8461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.06,56.02h-9.37V40.93c0-12.48-10.15-22.63-22.63-22.63h-62.87c-12.48,0-22.63,10.15-22.63,22.63v15.09 H45.58c-8.7,0-15.78,7.08-15.78,15.78v201.76c0,2.08,1.69,3.77,3.77,3.77h251.49c2.08,0,3.77-1.69,3.77-3.77V71.8 C288.84,63.1,281.76,56.02,273.06,56.02z M273.06,63.57c4.54,0,8.24,3.7,8.24,8.24v21.94h-17.6V63.57H273.06z M241.05,25.84 c8.32,0,15.09,6.77,15.09,15.09v99.04l-25.31-20.25c-0.69-0.55-1.52-0.83-2.36-0.83c-0.83,0-1.67,0.28-2.36,0.83l-25.31,20.25 V40.93c0-5.79-2.19-11.08-5.78-15.09H241.05z M163.09,40.93c0-8.32,6.77-15.09,15.09-15.09c8.32,0,15.09,6.77,15.09,15.09v15.09 h-30.18V40.93z M45.58,63.57h147.69v30.18H37.34V71.8C37.34,67.26,41.04,63.57,45.58,63.57z M37.34,269.79v-168.5h155.93v46.53 c0,1.45,0.83,2.77,2.14,3.4c1.31,0.63,2.86,0.45,3.99-0.45l29.08-23.26l29.08,23.26c0.68,0.55,1.52,0.83,2.36,0.83 c0.56,0,1.11-0.12,1.63-0.37c1.31-0.63,2.14-1.95,2.14-3.4v-46.53h17.6v168.5H37.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113327327378597979610000015395737090678067084_",
    gradientUnits: "userSpaceOnUse",
    x1: -905.4351,
    y1: -816.8274,
    x2: 1053.6799,
    y2: 1002.7518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113327327378597979610000015395737090678067084_)"
    },
    d: "M58.72,88.72c2.08,0,3.77-1.69,3.77-3.77 V72.37c0-2.08-1.69-3.77-3.77-3.77c-2.08,0-3.77,1.69-3.77,3.77v12.57C54.95,87.03,56.64,88.72,58.72,88.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150806031949407516500000005451114673166453946_",
    gradientUnits: "userSpaceOnUse",
    x1: -893.7841,
    y1: -829.3644,
    x2: 1065.323,
    y2: 990.2075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150806031949407516500000005451114673166453946_)"
    },
    d: "M83.87,88.72c2.08,0,3.77-1.69,3.77-3.77 V72.37c0-2.08-1.69-3.77-3.77-3.77s-3.77,1.69-3.77,3.77v12.57C80.1,87.03,81.79,88.72,83.87,88.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023968748977510148800000011906196296024165771_",
    gradientUnits: "userSpaceOnUse",
    x1: -882.1371,
    y1: -841.9051,
    x2: 1076.9701,
    y2: 977.6667
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023968748977510148800000011906196296024165771_)"
    },
    d: "M109.02,88.72c2.08,0,3.77-1.69,3.77-3.77 V72.37c0-2.08-1.69-3.77-3.77-3.77s-3.77,1.69-3.77,3.77v12.57C105.25,87.03,106.94,88.72,109.02,88.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088854953992439941460000002437736659045274033_",
    gradientUnits: "userSpaceOnUse",
    x1: -912.5598,
    y1: -809.1384,
    x2: 1046.5408,
    y2: 1010.4272
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088854953992439941460000002437736659045274033_)"
    },
    d: "M199.42,159.56l-20.8-3.02l-9.3-18.84 c-1.89-3.84-5.73-6.22-10.01-6.22s-8.11,2.38-10.01,6.22l-9.3,18.84l-20.8,3.02c-4.23,0.62-7.68,3.52-9.01,7.59 c-1.32,4.07-0.24,8.45,2.82,11.44l15.05,14.67l-3.55,20.71c-0.72,4.22,0.98,8.4,4.44,10.92c1.96,1.42,4.25,2.14,6.55,2.14 c1.77,0,3.56-0.43,5.2-1.29l18.6-9.78l18.6,9.78c3.79,1.99,8.29,1.66,11.75-0.85c3.46-2.52,5.16-6.7,4.44-10.92l-3.55-20.71 l15.05-14.67c3.07-2.99,4.15-7.37,2.82-11.44C207.11,163.08,203.66,160.17,199.42,159.56z M200.34,173.19l-16.47,16.05 c-0.89,0.87-1.3,2.12-1.09,3.34l3.89,22.67c0.24,1.39-0.3,2.71-1.44,3.54c-1.14,0.83-2.56,0.93-3.81,0.28l-20.36-10.7 c-0.55-0.29-1.15-0.43-1.76-0.43c-0.6,0-1.21,0.14-1.76,0.43l-20.36,10.7c-1.25,0.65-2.67,0.55-3.81-0.28 c-1.14-0.83-1.68-2.15-1.44-3.54l3.89-22.67c0.21-1.22-0.2-2.47-1.09-3.34l-16.47-16.05c-1.01-0.98-1.35-2.37-0.91-3.71 c0.43-1.34,1.53-2.26,2.92-2.46l22.76-3.31c1.23-0.18,2.29-0.95,2.84-2.06l10.18-20.62c0.62-1.26,1.83-2.02,3.24-2.02 c1.41,0,2.62,0.75,3.24,2.02l10.18,20.62c0.55,1.11,1.61,1.88,2.84,2.06l22.76,3.31c1.39,0.2,2.48,1.12,2.92,2.46 C201.69,170.82,201.35,172.21,200.34,173.19z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep04);
export default __webpack_public_path__ + "static/media/step_04.f935eecf22c1266fa27e727e61d8efd5.svg";
export { ForwardRef as ReactComponent };